import { createContext, useContext } from 'react';
import { AuthLoaderData } from '@/portal/types/AuthLoaderData.ts';

export const AuthContext = createContext<AuthLoaderData | null>(null);

export function useAuth(): AuthLoaderData {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an <AuthContext.Provider>');
  }
  return context;
}
